import { Canvas } from '@react-three/fiber'
import { OrbitControls } from '@react-three/drei'
import { useState } from 'react'
import Box, { IBox } from 'components/Container/Box'
import Container, { IContainer } from 'components/Container/Container';
import * as THREE from 'three'
import DimensionAxis from 'components/Container/DimensionAxis';
import CustomButton from 'components/common/CustomButton';
import { toast } from 'react-toastify';
import CustomSelect from 'components/common/CustomSelect';
import { boxList } from 'data/box';
import CustomInput from 'components/common/CustomInput';
import { ReactComponent as DelW } from 'assets/common/delWhite.svg'
import { jsonAxios } from 'components/axios';
import Loading from 'components/common/Loading';

const First = () => {
    const [loading, setLoading] = useState<boolean>(false);
    // 컨테이너 크기
    const [containerSize, setContainerSize] = useState<IContainer>({
        w: 10.854,
        h: 2.74,
        d: 4.85,
    });
    const [modifySize, setModifySize] = useState<IContainer>(containerSize);
    // 못올라가는것들
    const [] = useState();
    // 박스 크기
    const [boxes, setBoxes] = useState<IBox[]>([]);
    const [convertedBoxes, setConvertedBoxes] = useState<IBox[]>([]);

    // 눈금 보여주는 변수
    const [isAxis, setIsAxis] = useState<boolean>(true);

    const addBox = () => {
        if (boxes.length === 0) return toast.error('아이템을 선택해주세요.')
        setLoading(true)
        const expandedBoxes = boxes.flatMap(box =>
            Array.from({ length: box.amount }, () => {
                const { amount, ...rest } = box;
                return rest;
            })
        );

        const reqData = {
            containerSize: containerSize,
            boxes: expandedBoxes,
        };

        console.log('reqData >>>', reqData);

        jsonAxios.post(`container/optimize`, reqData).then(res => {
            console.log(res.data);
            if (res.data.code === 200) {
                setConvertedBoxes(res.data.placements);
                if (res.data.over && res.data.over.length > 0) {
                    toast.error('최대 갯수로 조절합니다.')
                    const updatedBoxes = res.data.over.reduce(
                        (acc: any, item: { id: string }) => {
                            const { id } = item;
                            for (const box of acc) {
                                if (box.id === id && box.amount > 0) {
                                    box.amount -= 1;
                                    break;
                                }
                            }
                            return acc;
                        },
                        [...boxes.map(box => ({ ...box }))]
                    );

                    setBoxes(updatedBoxes);
                }
            }
            else if (res.data.code === 400) {
                toast.error('오류입니다. 다시 시도해주세요.')
            }
        }).finally(() => {
            setTimeout(() => {
                setLoading(false)
            }, 400)
        })
    };

    const removeBox = (idx: number) => {
        setBoxes(p => p.filter((_, index) => index !== idx))
    }

    const toggleAxis = () => {
        setIsAxis(p => !p);
    }

    const modifyContainer = () => {
        setContainerSize(modifySize)
    }

    // 컨테이너-상대 (x_rel, y_rel, z_rel) → 씬-절대 (x_world, y_world, z_world)
    const toWorldPosition = (
        pos: [number, number, number],
        size: [number, number, number],
        containerSize: IContainer
    ): [number, number, number] => {
        const [x_rel, y_rel, z_rel] = pos;
        const [boxW, boxH, boxD] = size;
        const { w, h, d } = containerSize;

        return [
            (x_rel - w / 2) + boxW / 2,
            y_rel + boxH / 2,
            (z_rel - d / 2) + boxD / 2,
        ];
    }

    return (
        <div className="relative flex justify-center items-center w-full">
            <div className='top-0 left-0 z-40 absolute bg-[#222222] py-3 w-96 overflow-hidden text-white'
                style={{ height: 'calc(100vh - 80px)' }}
            >
                <div className='flex flex-col gap-3 px-4 w-full'>
                    <p className='my-3 font-semibold text-lg'>컨테이너</p>
                    <div>
                        <p>길이 / w (m)</p>
                        <CustomInput
                            type='number'
                            height={10}
                            className='text-black'
                            placeholder=''
                            value={modifySize.w}
                            onChange={(e) => {
                                setModifySize(p => ({
                                    ...p,
                                    w: Number(e.target.value)
                                }))
                            }}
                        />
                    </div>
                    <div>
                        <p>높이 / h (m)</p>
                        <CustomInput
                            type='number'
                            height={10}
                            className='text-black'
                            placeholder=''
                            value={modifySize.h}
                            onChange={(e) => {
                                setModifySize(p => ({
                                    ...p,
                                    h: Number(e.target.value)
                                }))
                            }}
                        />
                    </div>
                    <div>
                        <p>깊이 / d (m)</p>
                        <CustomInput
                            type='number'
                            height={10}
                            className='text-black'
                            placeholder=''
                            value={modifySize.d}
                            onChange={(e) => {
                                setModifySize(p => ({
                                    ...p,
                                    d: Number(e.target.value)
                                }))
                            }}
                        />
                    </div>

                    <CustomButton
                        className='bg-primary !h-10 !text-sm'
                        title={'컨테이너 수정'}
                        onClick={modifyContainer}
                    />
                    <CustomButton
                        className='bg-primary !h-10 !text-sm'
                        title={`눈금 ${isAxis ? '끄기' : '켜기'}`}
                        onClick={toggleAxis}
                    />

                    <p className='my-3 font-semibold text-lg'>아이템</p>

                    <CustomSelect
                        height={40}
                        fontSize={14}
                        option={boxList}
                        placeholder={'item 선택'}
                        onChange={(value, allData) => {
                            setBoxes(prev => {
                                // 새 아이템 추가
                                const newItem = {
                                    id: allData.label,
                                    color: allData.color ?? '#000000',
                                    position: [0, 0, 0] as [number, number, number],
                                    size: [allData.x ?? 0, allData.y ?? 0, allData.z ?? 0] as [number, number, number],
                                    isStackAble: false,
                                    isRotationAble: false,
                                    amount: 1,
                                };

                                return [newItem, ...prev];
                            });
                        }}
                    />
                    <div className='flex flex-col gap-3 w-full h-96 overflow-y-scroll'>
                        {
                            boxes.map((item, idx) => (
                                <div className='flex flex-col w-full' key={idx}>
                                    <div className='flex justify-between items-center w-full'>
                                        <div>
                                            <p>{item.id}</p>
                                            <p>{item.size[0]}m x {item.size[1]}m x {item.size[2]}m</p>
                                        </div>
                                        <DelW className='w-4' onClick={() => removeBox(idx)} />
                                    </div>

                                    {/* <div className='flex justify-between items-center py-3'>
                                        <p>적재여부</p>
                                        <ToggleSwitch
                                            isLabel={false}
                                            checked={item.isStackAble}
                                            onChange={(value) => {
                                                setBoxes(prev => {
                                                    const temp = [...prev];
                                                    temp[idx] = { ...temp[idx], isStackAble: value };
                                                    return temp;
                                                });
                                            }}
                                        />
                                    </div>

                                    <div className='flex justify-between items-center py-3'>
                                        <p>회전여부</p>
                                        <ToggleSwitch
                                            isLabel={false}
                                            checked={item.isRotationAble}
                                            onChange={(value) => {
                                                setBoxes(prev => {
                                                    const temp = [...prev];
                                                    temp[idx] = { ...temp[idx], isRotationAble: value };
                                                    return temp;
                                                });
                                            }}
                                        />
                                    </div> */}

                                    <div className='flex justify-between items-center py-3'>
                                        <p>수량</p>
                                        <div className="flex items-center gap-2">
                                            <button
                                                onClick={() => {
                                                    setBoxes(prev => {
                                                        const temp = [...prev];
                                                        const currentAmount = temp[idx].amount;
                                                        if (currentAmount > 1) {  // 최소 1개 유지
                                                            temp[idx] = { ...temp[idx], amount: currentAmount - 1 };
                                                        }
                                                        return temp;
                                                    });
                                                }}
                                                className="px-2 py-1"
                                            >-</button>
                                            <input
                                                className='bg-transparent w-20 text-center'
                                                type="number"
                                                value={item.amount}
                                                min={1}
                                                max={100}
                                                onChange={e => {
                                                    const value = Number(e.target.value);
                                                    setBoxes(prev => {
                                                        const temp = [...prev];
                                                        temp[idx] = {
                                                            ...temp[idx],
                                                            amount: value > 100 ? 100 : value < 1 ? 1 : value  // 1~100 사이로 강제 제한
                                                        };
                                                        return temp;
                                                    });
                                                }}
                                            />
                                            <button
                                                onClick={() => {
                                                    setBoxes(prev => {
                                                        const temp = [...prev];
                                                        temp[idx] = { ...temp[idx], amount: temp[idx].amount + 1 };
                                                        return temp;
                                                    });
                                                }}
                                                className="px-2 py-1"
                                            >+</button>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                    <CustomButton
                        className='bg-primary'
                        title='ITEM 적용'
                        onClick={addBox}
                        disabled={loading}
                    />
                </div>
            </div>

            {
                loading &&
                <div className='top-0 left-0 z-30 absolute flex justify-center items-center bg-[rgba(255,255,255,0.4)] py-3 w-full'
                    style={{ height: 'calc(100vh - 80px)' }}>
                    <Loading width={200} />
                </div>
            }
            <Canvas
                style={{ height: 'calc(100vh - 80px)' }}
                shadows
                camera={{ position: [10, 5, 10], fov: 50 }}
            >
                {/* 조명 */}
                <ambientLight intensity={0.5} />
                <spotLight
                    position={[10, 30, 10]}
                    angle={0.3}
                    penumbra={1}
                    intensity={1}
                    castShadow
                    shadow-mapSize-width={1024}
                    shadow-mapSize-height={1024}
                />

                {/* GridHelper 추가 */}
                <primitive
                    object={new THREE.GridHelper(containerSize.w, 40, '#3e3e3e', '#a8a8a8')}
                    rotation-x={0}
                    position={[0, 0.0001, 0]}
                />

                <Container size={containerSize} />

                {
                    convertedBoxes.map((item, idx) => (
                        <Box
                            key={idx}
                            id={item.id}
                            size={item.size}
                            color={item.color}
                            isVisible={item.isVisible}
                            position={toWorldPosition(item.position, item.size, containerSize)}
                        />
                    ))}

                {/* 축 눈금/레이블 */}
                {
                    isAxis &&
                    <DimensionAxis containerSize={containerSize} />
                }

                <OrbitControls />
            </Canvas>
        </div>
    )
}

export default First